import React, { useMemo, useState } from "react";
import ContentList from "../../../customUiForCs/ContentList";
import ZoneDropDownInput from "../sites/ZoneDropDownInput";
import EmployeeCard from "../employees/EmployeeCard";
import SiteDropDownInput from "../employees/SiteDropDownInput";
import DropDownInput from "../../../helperComponents/DropDownInput";
import contractTypesForSite from "../../../../data/employee/contractTypesForSite";
import Context from "../../../../Context";

export default function NomenclatureOfEmployee({
  columns = 1,
  initialRoleID,
  initialSiteID,
  disableRoleFilter,
  disableSiteFilter,
  nothingFoundMessage,
  disableFilters,
  inheritedSearchQuery,
  onCardClick,
  tableViewSettings,
  buttons,
  forcedIsActive,
}) {
  const [zoneID, setZoneID] = useState();
  const [siteID, setSiteID] = useState(initialSiteID ? initialSiteID : null);
  const [employeeResponsibility, setEmployeeResponsibility] = useState(null);
  const { employeeFunctions } = React.useContext(Context);
  const [roleID, setRoleID] = useState(initialRoleID ? initialRoleID : null);
  const [gender, setGender] = useState(null);
  const [isActive, setIsActive] = useState(forcedIsActive || "ALL");
  const [shift, setShift] = useState(null);
  const [accountType, setAccountType] = useState("EMPLOYEE");

  const queryParams = useMemo(
    () => ({
      zoneID,
      siteID,
      roleID,
      employeeResponsibility,
      gender,
      isActive: forcedIsActive || isActive,
      shift,
      accountType,
    }),
    [
      zoneID,
      siteID,
      roleID,
      employeeResponsibility,
      gender,
      isActive,
      shift,
      accountType,
      forcedIsActive,
    ]
  );

  return (
    <ContentList
      tableViewSettings={tableViewSettings}
      onCardClick={onCardClick}
      disableFilters={disableFilters}
      inheritedSearchQuery={inheritedSearchQuery}
      nothingFoundMessage={nothingFoundMessage}
      columns={columns}
      doReset={() => {
        setAccountType("EMPLOYEE");
        setShift(null);
        setZoneID(null);
        if (!disableSiteFilter) setSiteID(null);
        setEmployeeResponsibility(null);
        if (!disableRoleFilter) setRoleID(null);
        setGender(null);
        setIsActive(forcedIsActive || null);
      }}
      permissionName={"profilePermissions"}
      queryParams={queryParams}
      buttons={buttons}
      filters={
        <>
          {/* <DropDownInput
            options={employeeTypes}
            label={"Type du personnel"}
            value={accountType}
            onChange={setAccountType}
          /> */}

          {/* <DropDownInput
            label={"Shift"}
            options={employeeShiftTypes}
            value={shift}
            onChange={setShift}
          /> */}

          {/* <DropDownInput
          
            disableSearch={true}
            label="Actif"
            value={isActive}
            options={[
              { value: "ALL", label: "Toute" },
              { value: "TRUE", label: "Oui" },
              { value: "FALSE", label: "Non" },
            ]}
            onChange={setIsActive}
          /> */}

          <DropDownInput
            // style={dropDownStyle}
            disableSearch={true}
            label="Genre"
            value={gender}
            options={[
              { value: "MALE", label: "Homme" },
              { value: "FEMALE", label: "Femme" },
            ]}
            onChange={setGender}
          />

          {/* {disableRoleFilter ? null : (
            <RoleDropDownInput
              label={"Role"}
              value={roleID}
              onChange={setRoleID}
            />
          )} */}

          <DropDownInput
            label="Fonction"
            options={employeeFunctions || contractTypesForSite}
            value={employeeResponsibility}
            onChange={setEmployeeResponsibility}
          />

          {disableSiteFilter ? null : (
            <SiteDropDownInput
              onChange={setSiteID}
              value={siteID}
              label="Site"
            />
          )}

          <ZoneDropDownInput onChange={setZoneID} value={zoneID} label="Zone" />
        </>
      }
      title="Employés"
      path="employees"
      CardComponent={EmployeeCard}
    />
  );
}
